import { Link } from "react-router-dom"
import { LoggedInScreenCard } from "~/components/LoggedInScreenCard"
import { PageShell } from "~/components/PageShell"

export function ChangePasswordPage() {
  return (
    <PageShell innerClassName="max-w-lg w-full" fixedTabNav>
      <LoggedInScreenCard>
        <div className="w-full p-2">
          <h1 className="text-2xl font-semibold text-[var(--color-text-primary)]">Change password</h1>
          <p className="mt-2 text-sm text-[var(--color-text-secondary)]">
            Password changes will be available in a future update.
          </p>
          <Link
            to="/profile"
            className="mt-6 inline-block text-sm font-medium text-[var(--color-text-primary)] underline"
          >
            Back to Profile
          </Link>
        </div>
      </LoggedInScreenCard>
    </PageShell>
  )
}
